module.exports = __webpack_public_path__ + "static/media/objectsThumbnail.8cc89e07.jpg";